/* eslint-disable react/prop-types */
import React from 'react';

const combineComponents = (...components) => components.reverse().reduce(
  (AccumulatedComponents, CurrentComponent) => ({ children }) => (
    <AccumulatedComponents>
      <CurrentComponent>{children}</CurrentComponent>
    </AccumulatedComponents>
  ),
  ({ children }) => <>{children}</>,
);

export default combineComponents;
